export const LIST_EXAMINATION_RESULT_REQUEST = 'LIST_EXAMINATION_RESULT_REQUEST'
export const LIST_EXAMINATION_RESULT_SUCCESS = 'LIST_EXAMINATION_RESULT_SUCCESS'
export const LIST_EXAMINATION_RESULT_FAIL = 'LIST_EXAMINATION_RESULT_FAIL'

export const FINISH_EXAMINATION_RESULT_REQUEST =
  'FINISH_EXAMINATION_RESULT_REQUEST'
export const FINISH_EXAMINATION_RESULT_SUCCESS =
  'FINISH_EXAMINATION_RESULT_SUCCESS'
export const FINISH_EXAMINATION_RESULT_FAIL = 'FINISH_EXAMINATION_RESULT_FAIL'

export const RESEND_ORDER_LIS_EXAMINATION_RESULT_REQUEST =
  'RESEND_ORDER_LIS_EXAMINATION_RESULT_REQUEST'
export const RESEND_ORDER_LIS_EXAMINATION_RESULT_SUCCESS =
  'RESEND_ORDER_LIS_EXAMINATION_RESULT_SUCCESS'
export const RESEND_ORDER_LIS_EXAMINATION_RESULT_FAIL =
  'RESEND_ORDER_LIS_EXAMINATION_RESULT_FAIL'

export const LIST_EXAMINATION_ATTACHMENT_REQUEST =
  'LIST_EXAMINATION_ATTACHMENT_REQUEST'
export const LIST_EXAMINATION_ATTACHMENT_SUCCESS =
  'LIST_EXAMINATION_ATTACHMENT_SUCCESS'
export const LIST_EXAMINATION_ATTACHMENT_FAIL =
  'LIST_EXAMINATION_ATTACHMENT_FAIL'

export const LIST_EXAMINATION_RESULT_PATIENT_EXAMINATION_SUMMARY_REQUEST =
  'LIST_EXAMINATION_RESULT_PATIENT_EXAMINATION_SUMMARY_REQUEST'
export const LIST_EXAMINATION_RESULT_PATIENT_EXAMINATION_SUMMARY_SUCCESS =
  'LIST_EXAMINATION_RESULT_PATIENT_EXAMINATION_SUMMARY_SUCCESS'
export const LIST_EXAMINATION_RESULT_PATIENT_EXAMINATION_SUMMARY_FAIL =
  'LIST_EXAMINATION_RESULT_PATIENT_EXAMINATION_SUMMARY_FAIL'

export const SUBMIT_EXAMINATION_RESULT_PATIENT_EXAMINATION_REQUEST =
  'SUBMIT_EXAMINATION_RESULT_PATIENT_EXAMINATION_REQUEST'
export const SUBMIT_EXAMINATION_RESULT_PATIENT_EXAMINATION_SUCCESS =
  'SUBMIT_EXAMINATION_RESULT_PATIENT_EXAMINATION_SUCCESS'
export const SUBMIT_EXAMINATION_RESULT_PATIENT_EXAMINATION_FAIL =
  'SUBMIT_EXAMINATION_RESULT_PATIENT_EXAMINATION_FAIL'

export const TAX_ACTIVIRY_EXAMINATION_RESULT_PATIENT_EXAMINATION_REQUEST =
  'TAX_ACTIVIRY_EXAMINATION_RESULT_PATIENT_EXAMINATION_REQUEST'
export const TAX_ACTIVIRY_EXAMINATION_RESULT_PATIENT_EXAMINATION_SUCCESS =
  'TAX_ACTIVIRY_EXAMINATION_RESULT_PATIENT_EXAMINATION_SUCCESS'
export const TAX_ACTIVIRY_EXAMINATION_RESULT_PATIENT_EXAMINATION_FAIL =
  'TAX_ACTIVIRY_EXAMINATION_RESULT_PATIENT_EXAMINATION_FAIL'

export const DETAIL_PATIENT_EXAMINATION_RESULT_PATIENT_EXAMINATION_REQUEST =
  'DETAIL_PATIENT_EXAMINATION_RESULT_PATIENT_EXAMINATION_REQUEST'
export const DETAIL_PATIENT_EXAMINATION_RESULT_PATIENT_EXAMINATION_SUCCESS =
  'DETAIL_PATIENT_EXAMINATION_RESULT_PATIENT_EXAMINATION_SUCCESS'
export const DETAIL_PATIENT_EXAMINATION_RESULT_PATIENT_EXAMINATION_FAIL =
  'DETAIL_PATIENT_EXAMINATION_RESULT_PATIENT_EXAMINATION_FAIL'

export const LIST_MCU_PATIENT_RESULT_SUMMARY_REQUEST =
  'LIST_MCU_PATIENT_RESULT_SUMMARY_REQUEST'
export const LIST_MCU_PATIENT_RESULT_SUMMARY_SUCCESS =
  'LIST_MCU_PATIENT_RESULT_SUMMARY_SUCCESS'
export const LIST_MCU_PATIENT_RESULT_SUMMARY_FAIL =
  'LIST_MCU_PATIENT_RESULT_SUMMARY_FAIL'

export const DETAIL_PATIENT_EXAMINATION_RESULT_PATIENT_TEETH_REQUEST =
  'DETAIL_PATIENT_EXAMINATION_RESULT_PATIENT_TEETH_REQUEST'
export const DETAIL_PATIENT_EXAMINATION_RESULT_PATIENT_TEETH_SUCCESS =
  'DETAIL_PATIENT_EXAMINATION_RESULT_PATIENT_TEETH_SUCCESS'
export const DETAIL_PATIENT_EXAMINATION_RESULT_PATIENT_TEETH_FAIL =
  'DETAIL_PATIENT_EXAMINATION_RESULT_PATIENT_TEETH_FAIL'

export const LOG_TASK_ACTIVITY_REQUEST = 'LOG_TASK_ACTIVITY_REQUEST'
export const LOG_TASK_ACTIVITY_SUCCESS = 'LOG_TASK_ACTIVITY_SUCCESS'
export const LOG_TASK_ACTIVITY_FAIL = 'LOG_TASK_ACTIVITY_FAIL'

export const DELETE_ATTACHMENT_MCU_REQUEST = 'DELETE_ATTACHMENT_MCU_REQUEST'
export const DELETE_ATTACHMENT_MCU_SUCCESS = 'DELETE_ATTACHMENT_MCU_SUCCESS'
export const DELETE_ATTACHMENT_MCU_FAIL = 'DELETE_ATTACHMENT_MCU_FAIL'

export const ACTION_SUBMIT_PATIENT_EXAMINATION_RESULT_PATIENT_EXAMINATION_REQUEST =
  'ACTION_SUBMIT_PATIENT_EXAMINATION_RESULT_PATIENT_EXAMINATION_REQUEST'
export const ACTION_SUBMIT_PATIENT_EXAMINATION_RESULT_PATIENT_EXAMINATION_SUCCESS =
  'ACTION_SUBMIT_PATIENT_EXAMINATION_RESULT_PATIENT_EXAMINATION_SUCCESS'
export const ACTION_SUBMIT_PATIENT_EXAMINATION_RESULT_PATIENT_EXAMINATION_FAIL =
  'ACTION_SUBMIT_PATIENT_EXAMINATION_RESULT_PATIENT_EXAMINATION_FAIL'

export const UPDATE_EXAMINATION_RESULT_PATIENT_EXAMINATION_REQUEST =
  'UPDATE_EXAMINATION_RESULT_PATIENT_EXAMINATION_REQUEST'
export const UPDATE_EXAMINATION_RESULT_PATIENT_EXAMINATION_SUCCESS =
  'UPDATE_EXAMINATION_RESULT_PATIENT_EXAMINATION_SUCCESS'
export const UPDATE_EXAMINATION_RESULT_PATIENT_EXAMINATION_FAIL =
  'UPDATE_EXAMINATION_RESULT_PATIENT_EXAMINATION_FAIL'

export const CANCEL_EXAMINATION_RESULT_PATIENT_EXAMINATION_REQUEST =
  'CANCEL_EXAMINATION_RESULT_PATIENT_EXAMINATION_REQUEST'
export const CANCEL_EXAMINATION_RESULT_PATIENT_EXAMINATION_SUCCESS =
  'CANCEL_EXAMINATION_RESULT_PATIENT_EXAMINATION_SUCCESS'
export const CANCEL_EXAMINATION_RESULT_PATIENT_EXAMINATION_FAIL =
  'CANCEL_EXAMINATION_RESULT_PATIENT_EXAMINATION_FAIL'

export const ACTION_PATIENT_EXAMINATION_RESULT_PATIENT_EXAMINATION_REQUEST =
  'ACTION_PATIENT_EXAMINATION_RESULT_PATIENT_EXAMINATION_REQUEST'
export const ACTION_PATIENT_EXAMINATION_RESULT_PATIENT_EXAMINATION_SUCCESS =
  'ACTION_PATIENT_EXAMINATION_RESULT_PATIENT_EXAMINATION_SUCCESS'
export const ACTION_PATIENT_EXAMINATION_RESULT_PATIENT_EXAMINATION_FAIL =
  'ACTION_PATIENT_EXAMINATION_RESULT_PATIENT_EXAMINATION_FAIL'

export const TYPE_ACTION_EXAMINATION_RESULT_PATIENT_EXAMINATION =
  'TYPE_ACTION_EXAMINATION_RESULT_PATIENT_EXAMINATION'

export const RE_ITEM_EXAMINATION_RESULT_PATIENT_EXAMINATION_REQUEST =
  'RE_ITEM_EXAMINATION_RESULT_PATIENT_EXAMINATION_REQUEST'
export const RE_ITEM_EXAMINATION_RESULT_PATIENT_EXAMINATION_SUCCESS =
  'RE_ITEM_EXAMINATION_RESULT_PATIENT_EXAMINATION_SUCCESS'
export const RE_ITEM_EXAMINATION_RESULT_PATIENT_EXAMINATION_FAIL =
  'RE_ITEM_EXAMINATION_RESULT_PATIENT_EXAMINATION_FAIL'

export const GENERATE_ITEM_EXAMINATION_RESULT_PATIENT_EXAMINATION_REQUEST =
  'GENERATE_ITEM_EXAMINATION_RESULT_PATIENT_EXAMINATION_REQUEST'
export const GENERATE_ITEM_EXAMINATION_RESULT_PATIENT_EXAMINATION_SUCCESS =
  'GENERATE_ITEM_EXAMINATION_RESULT_PATIENT_EXAMINATION_SUCCESS'
export const GENERATE_ITEM_EXAMINATION_RESULT_PATIENT_EXAMINATION_FAIL =
  'GENERATE_ITEM_EXAMINATION_RESULT_PATIENT_EXAMINATION_FAIL'

export const HISTORY_PATIENT_EXAMINATION_RESULT_PATIENT_EXAMINATION_REQUEST =
  'HISTORY_PATIENT_EXAMINATION_RESULT_PATIENT_EXAMINATION_REQUEST'
export const HISTORY_PATIENT_EXAMINATION_RESULT_PATIENT_EXAMINATION_SUCCESS =
  'HISTORY_PATIENT_EXAMINATION_RESULT_PATIENT_EXAMINATION_SUCCESS'
export const HISTORY_PATIENT_EXAMINATION_RESULT_PATIENT_EXAMINATION_FAIL =
  'HISTORY_PATIENT_EXAMINATION_RESULT_PATIENT_EXAMINATION_FAIL'

export const PRINT_PREVIEW_EXAMINATION_RESULT_PATIENT_EXAMINATION_REQUEST =
  'PRINT_PREVIEW_EXAMINATION_RESULT_PATIENT_EXAMINATION_REQUEST'
export const PRINT_PREVIEW_EXAMINATION_RESULT_PATIENT_EXAMINATION_SUCCESS =
  'PRINT_PREVIEW_EXAMINATION_RESULT_PATIENT_EXAMINATION_SUCCESS'
export const PRINT_PREVIEW_EXAMINATION_RESULT_PATIENT_EXAMINATION_FAIL =
  'PRINT_PREVIEW_EXAMINATION_RESULT_PATIENT_EXAMINATION_FAIL'

export const CREATE_NEW_RESULT_EXAMINATION_RESULT_PATIENT_EXAMINATION_REQUEST =
  'CREATE_NEW_RESULT_EXAMINATION_RESULT_PATIENT_EXAMINATION_REQUEST'
export const CREATE_NEW_RESULT_EXAMINATION_RESULT_PATIENT_EXAMINATION_SUCCESS =
  'CREATE_NEW_RESULT_EXAMINATION_RESULT_PATIENT_EXAMINATION_SUCCESS'
export const CREATE_NEW_RESULT_EXAMINATION_RESULT_PATIENT_EXAMINATION_FAIL =
  'CREATE_NEW_RESULT_EXAMINATION_RESULT_PATIENT_EXAMINATION_FAIL'

export const SUBMIT_TASK_EXAMINATION_RESULT_PATIENT_REQUEST =
  'SUBMIT_TASK_EXAMINATION_RESULT_PATIENT_REQUEST'
export const SUBMIT_TASK_EXAMINATION_RESULT_PATIENT_SUCCESS =
  'SUBMIT_TASK_EXAMINATION_RESULT_PATIENT_SUCCESS'
export const SUBMIT_TASK_EXAMINATION_RESULT_PATIENT_FAIL =
  'SUBMIT_TASK_EXAMINATION_RESULT_PATIENT_FAIL'

export const IMPORT_REVIEW_RESULT_REQUEST = 'IMPORT_REVIEW_RESULT_REQUEST'
export const IMPORT_REVIEW_RESULT_SUCCESS = 'IMPORT_REVIEW_RESULT_SUCCESS'
export const IMPORT_REVIEW_RESULT_FAIL = 'IMPORT_REVIEW_RESULT_FAIL'

export const LIST_IMPORT_REVIEW_RESULT_REQUEST =
  'LIST_IMPORT_REVIEW_RESULT_REQUEST'
export const LIST_IMPORT_REVIEW_RESULT_SUCCESS =
  'LIST_IMPORT_REVIEW_RESULT_SUCCESS'
export const LIST_IMPORT_REVIEW_RESULT_FAIL = 'LIST_IMPORT_REVIEW_RESULT_FAIL'

export const EXPORT_VALIDATION_RESULT_REQUEST =
  'EXPORT_VALIDATION_RESULT_REQUEST'
export const EXPORT_VALIDATION_RESULT_SUCCESS =
  'EXPORT_VALIDATION_RESULT_SUCCESS'
export const EXPORT_VALIDATION_RESULT_FAIL = 'EXPORT_VALIDATION_RESULT_FAIL'

export const LIST_EXPORT_VALIDATION_RESULT_REQUEST =
  'LIST_EXPORT_VALIDATION_RESULT_REQUEST'
export const LIST_EXPORT_VALIDATION_RESULT_SUCCESS =
  'LIST_EXPORT_VALIDATION_RESULT_SUCCESS'
export const LIST_EXPORT_VALIDATION_RESULT_FAIL =
  'LIST_EXPORT_VALIDATION_RESULT_FAIL'

export const DOWNLOAD_EXPORT_VALIDATION_RESULT_REQUEST =
  'DOWNLOAD_EXPORT_VALIDATION_RESULT_REQUEST'
export const DOWNLOAD_EXPORT_VALIDATION_RESULT_SUCCESS =
  'DOWNLOAD_EXPORT_VALIDATION_RESULT_SUCCESS'
export const DOWNLOAD_EXPORT_VALIDATION_RESULT_FAIL =
  'DOWNLOAD_EXPORT_VALIDATION_RESULT_FAIL'

export const LIST_DETAIL_IMPORT_REVIEW_RESULT_REQUEST =
  'LIST_DETAIL_IMPORT_REVIEW_RESULT_REQUEST'
export const LIST_DETAIL_IMPORT_REVIEW_RESULT_SUCCESS =
  'LIST_DETAIL_IMPORT_REVIEW_RESULT_SUCCESS'
export const LIST_DETAIL_IMPORT_REVIEW_RESULT_FAIL =
  'LIST_DETAIL_IMPORT_REVIEW_RESULT_FAIL'

export const DETAIL_IMPORT_REVIEW_RESULT_REQUEST =
  'DETAIL_IMPORT_REVIEW_RESULT_REQUEST'
export const DETAIL_IMPORT_REVIEW_RESULT_SUCCESS =
  'DETAIL_IMPORT_REVIEW_RESULT_SUCCESS'
export const DETAIL_IMPORT_REVIEW_RESULT_FAIL =
  'DETAIL_IMPORT_REVIEW_RESULT_FAIL'

export const EXPORT_IMPORT_REVIEW_RESULT_REQUEST =
  'EXPORT_IMPORT_REVIEW_RESULT_REQUEST'
export const EXPORT_IMPORT_REVIEW_RESULT_SUCCESS =
  'EXPORT_IMPORT_REVIEW_RESULT_SUCCESS'
export const EXPORT_IMPORT_REVIEW_RESULT_FAIL =
  'EXPORT_IMPORT_REVIEW_RESULT_FAIL'

export const DOWNLOAD_TEMPLATE_IMPORT_REVIEW_RESULT_REQUEST =
  'DOWNLOAD_TEMPLATE_IMPORT_REVIEW_RESULT_REQUEST'
export const DOWNLOAD_TEMPLATE_IMPORT_REVIEW_RESULT_SUCCESS =
  'DOWNLOAD_TEMPLATE_IMPORT_REVIEW_RESULT_SUCCESS'
export const DOWNLOAD_TEMPLATE_IMPORT_REVIEW_RESULT_FAIL =
  'DOWNLOAD_TEMPLATE_IMPORT_REVIEW_RESULT_FAIL'

export const CLEAR_IMPORT_REVIEW_RESULT = 'CLEAR_IMPORT_REVIEW_RESULT'

export const SELECT_SUMMARY_RECOMMENDATION_REQUEST =
  'SELECT_SUMMARY_RECOMMENDATION_REQUEST'
export const SELECT_SUMMARY_RECOMMENDATION_SUCCESS =
  'SELECT_SUMMARY_RECOMMENDATION_SUCCESS'
export const SELECT_SUMMARY_RECOMMENDATION_FAIL =
  'SELECT_SUMMARY_RECOMMENDATION_FAIL'

export const SUBMIT_ALL_EXAMINATION_RESULT_REQUEST =
  'SUBMIT_ALL_EXAMINATION_RESULT_REQUEST'
export const SUBMIT_ALL_EXAMINATION_RESULT_SUCCESS =
  'SUBMIT_ALL_EXAMINATION_RESULT_SUCCESS'
export const SUBMIT_ALL_EXAMINATION_RESULT_FAIL =
  'SUBMIT_ALL_EXAMINATION_RESULT_FAIL'

export const VALIDATION_BULK_UPLOAD_FILE_REQUEST =
  'VALIDATION_BULK_UPLOAD_FILE_REQUEST'
export const VALIDATION_BULK_UPLOAD_FILE_SUCCESS =
  'VALIDATION_BULK_UPLOAD_FILE_SUCCESS'
export const VALIDATION_BULK_UPLOAD_FILE_FAIL =
  'VALIDATION_BULK_UPLOAD_FILE_FAIL'

export const CANCEL_SUBMIT_ALL_EXAMINATION_RESULT_REQUEST = 'CANCEL_SUBMIT_ALL_EXAMINATION_RESULT_REQUEST'
export const CANCEL_SUBMIT_ALL_EXAMINATION_RESULT_SUCCESS = 'CANCEL_SUBMIT_ALL_EXAMINATION_RESULT_SUCCESS'
export const CANCEL_SUBMIT_ALL_EXAMINATION_RESULT_FAIL = 'CANCEL_SUBMIT_ALL_EXAMINATION_RESULT_FAIL'

export const EXPORT_REVIEW_RESULT_REQUEST = 'EXPORT_REVIEW_RESULT_REQUEST'
export const EXPORT_REVIEW_RESULT_SUCCESS = 'EXPORT_REVIEW_RESULT_SUCCESS'
export const EXPORT_REVIEW_RESULT_FAIL = 'EXPORT_REVIEW_RESULT_FAIL'

export const EXPORT_TASK_ACTIVITY_REQUEST = 'EXPORT_TASK_ACTIVITY_REQUEST'
export const EXPORT_TASK_ACTIVITY_SUCCESS = 'EXPORT_TASK_ACTIVITY_SUCCESS'
export const EXPORT_TASK_ACTIVITY_FAIL = 'EXPORT_TASK_ACTIVITY_FAIL'

export const INCLUDE_RESUME_EXAMINATION_RESULT_REQUEST = 'INCLUDE_RESUME_EXAMINATION_RESULT_REQUEST'
export const INCLUDE_RESUME_EXAMINATION_RESULT_SUCCESS = 'INCLUDE_RESUME_EXAMINATION_RESULT_SUCCESS'
export const INCLUDE_RESUME_EXAMINATION_RESULT_FAIL = 'INCLUDE_RESUME_EXAMINATION_RESULT_FAIL'

export const HISTORY_LOGS_REQUEST = 'HISTORY_LOGS_REQUEST'
export const HISTORY_LOGS_SUCCESS = 'HISTORY_LOGS_SUCCESS'
export const HISTORY_LOGS_FAIL = 'HISTORY_LOGS_FAIL'

export const UPDATE_NOTE_EXAMINATION_RESULT_REQUEST = 'UPDATE_NOTE_EXAMINATION_RESULT_REQUEST'
export const UPDATE_NOTE_EXAMINATION_RESULT_SUCCESS = 'UPDATE_NOTE_EXAMINATION_RESULT_SUCCESS'
export const UPDATE_NOTE_EXAMINATION_RESULT_FAIL = 'UPDATE_NOTE_EXAMINATION_RESULT_FAIL'

export const BULK_PUBLISH_NOT_PUBLISH_EXAMINATION_RESULT_REQUEST = 'BULK_PUBLISH_NOT_PUBLISH_EXAMINATION_RESULT_REQUEST'
export const BULK_PUBLISH_NOT_PUBLISH_EXAMINATION_RESULT_SUCCESS = 'BULK_PUBLISH_NOT_PUBLISH_EXAMINATION_RESULT_SUCCESS'
export const BULK_PUBLISH_NOT_PUBLISH_EXAMINATION_RESULT_FAIL = 'BULK_PUBLISH_NOT_PUBLISH_EXAMINATION_RESULT_FAIL'

export const BULK_REFERENCE_EXAMINATION_RESULT_REQUEST = 'BULK_REFERENCE_EXAMINATION_RESULT_REQUEST'
export const BULK_REFERENCE_EXAMINATION_RESULT_SUCCESS = 'BULK_REFERENCE_EXAMINATION_RESULT_SUCCESS'
export const BULK_REFERENCE_EXAMINATION_RESULT_FAIL = 'BULK_REFERENCE_EXAMINATION_RESULT_FAIL'
